import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'invd-fee-schedules-container',
  templateUrl: './fee-schedules-container.component.html',
  styleUrls: ['./fee-schedules-container.component.scss'],
})
export class FeeSchedulesContainerComponent {}
